import { FC } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface Props {
  name: string;
  value: string;
  error?: boolean;
  country: string;
  placeholder: string;
  isdisabled?: boolean;
  className?: string;
  setFieldValue: (field: string, value: string) => void;
}

export const InputPhone: FC<Props> = ({
  name,
  value,
  isdisabled,
  placeholder,
  country,
  error,
  className = '',
  setFieldValue,
}) => {
  return (
    <div className="relative w-full">
      <PhoneInput
        value={value}
        country={country}
        disabled={isdisabled}
        placeholder={placeholder}
        onChange={(...args: any[]) => setFieldValue(name, args[3] as string)}
        containerClass="!w-full"
        containerStyle={{ width: '100%', height: '38px' }}
        buttonClass="!bg-transparent"
        inputClass={`block w-full border rounded-md pl-12 p-2 placeholder:text-gray-400 !border-gray-200 dark:ring-gray-600 dark:placeholder:text-gray-500 placeholder:text-sm text-sm text-gray-900 dark:text-white bg-white dark:bg-gray-800 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 ${
          error
            ? '!border-red-500 focus:!border-red-500 focus:!ring-red-500'
            : '!border !border-gray-300 dark:! !border-gray-600'
        } ${className}`}
        inputStyle={{ width: '100%', height: '38px' }}
        inputProps={{ name }}
      />
    </div>
  );
};
